import { render, staticRenderFns } from "./TotalDetail.vue?vue&type=template&id=62f55bcd&scoped=true"
import script from "./TotalDetail.vue?vue&type=script&lang=js"
export * from "./TotalDetail.vue?vue&type=script&lang=js"
import style0 from "./TotalDetail.vue?vue&type=style&index=0&id=62f55bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f55bcd",
  null
  
)

export default component.exports